import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select.tsx"

interface TablePageSizeSelectorProps {
  size: string
  options: number[]
  onChange: (size: string) => void
}

export function TablePageSizeSelector({
  size,
  options,
  onChange,
}: TablePageSizeSelectorProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-sm text-muted-foreground whitespace-nowrap">Rows</span>
      <Select value={size} onValueChange={v => onChange(v)}>
        <SelectTrigger className="!h-[32px] w-[70px] text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map(size => (
            <SelectItem key={size} value={String(size)} className="text-sm">
              {size}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}